import * as React from 'react';

export const ClocksIcon = () => {
    return (
        <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 0.85H0.85V1V4.3V4.35799L0.889009 4.4009L2.79728 6.5L0.889009 8.5991L0.85 8.64201V8.7V12V12.15H1H7H7.15V12V8.7V8.64201L7.11099 8.5991L5.20272 6.5L7.11099 4.4009L7.15 4.35799V4.3V1V0.85H7H1ZM4 6.99799L5.85 9.03299V10.75H2.15V9.03299L4 6.99799ZM5.85 3.96701L4 6.00201L2.15 3.96701V2.25H5.85V3.96701Z" fill="var(--system-yellow)" stroke="var(--system-yellow)" stroke-width="0.3"/>
        </svg>
    );
};
